<template>
  <div :class="['loader-container', { 'hide-loader': isHidden }]">
    <div class="loader" />
  </div>
</template>

<script>
export default {
  name: 'LoaderView',
  props: {
    isHidden: {
      type: Boolean,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@keyframes bounce {
  0% {
    box-shadow: -15px 10px 0 rgba(204, 204, 204, 0),
      0 10px rgba(204, 204, 204, 0), 15px 10px rgba(204, 204, 204, 0);
  }
  16% {
    box-shadow: -15px 10px 0 #ccc, 0 10px rgba(204, 204, 204, 0),
      15px 10px rgba(204, 204, 204, 0);
  }
  32% {
    box-shadow: -15px 10px 0 #ccc, 0 10px #ccc, 15px 10px rgba(204, 204, 204, 0);
  }
  48% {
    box-shadow: -15px 10px 0 #ccc, 0 10px #ccc, 15px 10px #ccc;
  }
  66% {
    box-shadow: -15px 10px 0 rgba(204, 204, 204, 0), 0 10px #ccc, 15px 10px #ccc;
  }
  82% {
    box-shadow: -15px 10px 0 rgba(204, 204, 204, 0),
      0 10px rgba(204, 204, 204, 0), 15px 10px #ccc;
  }
  100% {
    box-shadow: -15px 10px 0 rgba(204, 204, 204, 0),
      0 10px rgba(204, 204, 204, 0), 15px 10px rgba(204, 204, 204, 0);
  }
}

.loader-container {
  margin: 0 auto;
  min-height: 160px;
  width: 100%;
  height: 100%;
  position: relative;
}

.loader {
  height: 30px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}

.loader:after {
  content: ' ';
  display: block;
  margin: 0 auto;
  background: transparent;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  animation: bounce 1s infinite ease-in-out;
  box-shadow: -15px 10px 0 rgba(204, 204, 204, 0), 0 10px rgba(204, 204, 204, 0),
    15px 10px rgba(204, 204, 204, 0);
}

.hide-loader {
  display: none;
}
</style>
